module.exports = __webpack_public_path__ + "static/media/landing-layer1.48401344.png";